export const CONVENTION_REGISTRANT_KIND = 'conventionRegistrant' as const

export type ConventionPaymentPlanMeta = {
  enabled?: boolean
  dueDates?: string[]
  numberOfInstallments?: number
  totalAmount?: number
  installmentAmount?: number
  conventionProductId?: number
}

export type ConventionRegistrantMeta = {
  kind: typeof CONVENTION_REGISTRANT_KIND
  schemaVersion?: number
  conventionProductId?: number
  registrationOptionId?: number | null
  paymentPlan?: ConventionPaymentPlanMeta
}

export function parseJsonObject(json: string | null | undefined): unknown | null {
  if (!json) return null
  try {
    return JSON.parse(json) as unknown
  } catch {
    return null
  }
}

export function parseConventionRegistrantMeta(
  metadata: string | null | undefined
): ConventionRegistrantMeta | null {
  const meta = parseJsonObject(metadata)
  if (!meta || typeof meta !== 'object') return null

  const kind = (meta as any)?.kind
  if (kind !== CONVENTION_REGISTRANT_KIND) return null

  return meta as ConventionRegistrantMeta
}

export function isConventionRegistrant(metadata: string | null | undefined) {
  return parseConventionRegistrantMeta(metadata) != null
}

export function isConventionPaymentPlanEnabled(
  metadata: string | null | undefined
) {
  const meta = parseConventionRegistrantMeta(metadata)
  return meta?.paymentPlan?.enabled === true
}


